import React from 'react';

const Footer = () => {
    return (
        <footer id="footer" className="bg-purple-800 text-white mt-6 py-6">
            <div className="text-sm mt-4 md:mt-0 text-center">
                <p>&copy; 2024 J Shiva Shankar. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
